import React, { useState,
  useContext, useEffect, }  from 'react';
import { historyPropType }  from '~/config/routerPropTypes';
import { showTourImage }    from '~/config/routes';
import Request              from '~/providers/Request';
import TourImage            from './context';
import TourImageRecord      from '~/records/TourImageRecord';
import Form                 from './Form';

function EditTourImage({history}){
  const [ record, setRecord] = useState(new TourImageRecord());
  const [ loading, setLoading] = useState(false);
  const { records, addRecords } = useContext(TourImage);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id){
      if(records && records[id]){
        record.updateAttributes(records[id]);
      }

      setLoading(true);
      Request.get(`/admin/tour_images/${id}`, {})
        .then( response => {
          setLoading(false);
          addRecords({ data: [response.data] });
          setRecord( record.updateAttributes(response.data) );
        })
        .catch( e => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  async function onSubmit (){
    let archive_id = record.get('archive_id') ? record.get('archive_id') : null;
    const imageBase64 = record.get('image_base64');
    setLoading(true);
    if(imageBase64){
      try {
        const result = await Request.post('/upload_base64', { file: `data:image/jpg;base64,${imageBase64}` });
        archive_id = result.data.id;
      } catch(e) {console.log(e);}
    }

    const data = record.toParams({archive_id});
    Request.put(`/admin/tour_images/${id}`, data, {}, { controller: 'tourImage' })
      .then((resp) => {
        setLoading(false);
          history.push(showTourImage.reverse(resp.data));
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
    />
  );
}

EditTourImage.propTypes={
  history: historyPropType,
};

export default EditTourImage;
